import { render, staticRenderFns } from "./submitSuccessPage.vue?vue&type=template&id=fac48492&scoped=true&"
import script from "./submitSuccessPage.vue?vue&type=script&lang=js&"
export * from "./submitSuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./submitSuccessPage.vue?vue&type=style&index=0&id=fac48492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac48492",
  null
  
)

export default component.exports